module.exports = __webpack_public_path__ + "static/img/level-card-banner2.7ce8c1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/3/level-card-banner2.png
// module id = Zj9s
// module chunks = 1